export default __webpack_public_path__ + "static/comparisons-control-transparency-65c714fd15822cf24dfe2a1aef833432.png";